import { v4 as uuidv4 } from 'uuid';
import { getState } from '~src/state';

export const uploadQrCode = async (qrBlob) => {
  const attachmentsUploader = getState('uploader.allegati');

  const filename = `qrcode-${uuidv4()}.png`;

  attachmentsUploader.addFile({
    name: filename,
    type: qrBlob.type,
    data: qrBlob,
  });

  const response = await attachmentsUploader.upload();

  attachmentsUploader.cancelAll();

  const url = `${process.env.EDGE_RESIZER}${
    new URL(response.successful[0].uploadURL).pathname
  }`;

  return url;
};
